<script>
export default {
  emits: ['onRegistrationSelected'],
  props: {
    visible: Boolean,
    closeOnClickOutside: Boolean,
    title: String,
    width: {
      type: String,
      default: '400px'
    },
    options: {
      type: Array,
      default: () => [{
        key: 'opcao1',
        label: 'Opção 1'
      }, {
        key: 'opcao2',
        label: 'Opção 2'
      }]
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeModal')
    }
  }
}
</script>

<template>
 <el-dialog
    :visible.sync="visible"
    :width="width"
    :show-close="showClose"
    :close-on-click-modal="closeOnClickOutside"
    :before-close="handleClose"
    class="sedap-registration-type-modal"
  >
  <template #title>
    <h6 class="sedap-registration-type-modal__title">{{ title }}</h6>
  </template>

  <ul class="sedap-registration-type-modal__list">
    <li v-for="option in options" :key="option.key" @click="$emit('onRegistrationSelected', option.key)">
      {{ option.label }}
    </li>
  </ul>

 </el-dialog>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/RegistrationType/RegistrationType.vue